export default __webpack_public_path__ + "static/media/logo-jira-work-management.20e49044.svg";